import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';

// The recruiter mode picks a vacancy or a request 2.0, which has no vacancy
export const useValidationSchemaRecruiterMode = () => {
  const { t } = useTranslation();
  const validationSchema = useMemo(() => {
    return Yup.object().shape({
      vacancyId: Yup.string().when('requestId', {
        is: (requestId?: string) => !requestId,
        then: (schema) => schema.required(t('errors.requiredField')),
      }),
      vacancyName: Yup.string(),
      requestId: Yup.string(),
    });
  }, [t]);

  return { validationSchema };
};
